module.exports = __webpack_public_path__ + "static/media/1017238.aec42359.jpg";